
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/articles/[id]",
      function () {
        return require("private-next-pages/destinations/articles/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/articles/[id]"])
      });
    }
  